"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingCard = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
/**
 * 요금제 하나를 담는 카드. 요금제 이름과 설명, 결제 주기당 가격, 포함 혜택을 한 장에 보여준다.
 * 배지는 badge 슬롯으로, 가입·업그레이드 버튼은 action 슬롯으로 받아 표기와 동작을 소비자가 정한다.
 */
let PricingCard = class PricingCard extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.plan = '';
        this.description = '';
        this.price = '';
        this.period = '';
        this.features = [];
    }
    render() {
        return (0, lit_1.html) `
      <mm-text-block level="3" heading=${this.plan} description=${this.description}></mm-text-block>
      <div class="price">
        <mm-text size="32" weight="bold">${this.price}</mm-text>
        <mm-text color="light">${this.period}</mm-text>
      </div>
      <slot name="action"></slot>
      ${this.renderFeatures()}
      <slot name="badge"></slot>
    `;
    }
    renderFeatures() {
        if (!this.features.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text-list .texts=${this.features}></mm-text-list>
    `;
    }
};
PricingCard.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
      position: relative;
    }

    /* 배지는 흐름에서 빼 카드 우측 상단에 둔다. 배지 유무와 관계없이 카드끼리 제목 줄이 맞는다. */
    ::slotted([slot='badge']) {
      position: absolute;
      top: 0;
      right: 0;
    }

    .price {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PricingCard.prototype, "plan", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PricingCard.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PricingCard.prototype, "price", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PricingCard.prototype, "period", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], PricingCard.prototype, "features", void 0);
PricingCard = __decorate([
    (0, decorators_js_1.customElement)('mm-pricing-card')
], PricingCard);
exports.PricingCard = PricingCard;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpY2luZy1jYXJkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicHJpY2luZy1jYXJkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsK0JBQTRCO0FBRTVCOzs7R0FHRztBQUVJLElBQU0sV0FBVyxHQUFqQixNQUFNLFdBQVksU0FBUSxnQkFBVTtJQUFwQzs7UUF1QnVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNoQixVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ1YsV0FBTSxHQUFHLEVBQUUsQ0FBQTtRQUNQLGFBQVEsR0FBYSxFQUFFLENBQUE7SUFzQnpELENBQUM7SUFwQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7eUNBQzBCLElBQUksQ0FBQyxJQUFJLGdCQUFnQixJQUFJLENBQUMsV0FBVzs7MkNBRXZDLElBQUksQ0FBQyxLQUFLO2lDQUNwQixJQUFJLENBQUMsTUFBTTs7O1FBR3BDLElBQUksQ0FBQyxjQUFjLEVBQUU7O0tBRXhCLENBQUE7SUFDSCxDQUFDO0lBRU8sY0FBYztRQUNwQixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFekMsT0FBTyxJQUFBLFVBQUksRUFBQTs2QkFDYyxJQUFJLENBQUMsUUFBUTtLQUNyQyxDQUFBO0lBQ0gsQ0FBQzs7QUEvQ00sa0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBcUJsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt5Q0FBVTtBQUNUO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztnREFBaUI7QUFDaEI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFZO0FBQ1A7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOzZDQUF3QjtBQTNCNUMsV0FBVztJQUR2QixJQUFBLDZCQUFhLEVBQUMsaUJBQWlCLENBQUM7R0FDcEIsV0FBVyxDQWlEdkI7QUFqRFksa0NBQVcifQ==